import { useCallback } from 'react'

import { useSegment } from '../../../../../hooks'
import type { InvoicingSettingsSection } from '../../../enums/invoicingSettingsSection'
import { useTrackInvoicingSettings } from '../../../hooks/useTrackInvoicingSettings'
import { AutomaticPaymentRemindersType } from '../enums/automaticPaymentRemindersType'

const trackingEventNameByType: Record<AutomaticPaymentRemindersType, string> = {
  [AutomaticPaymentRemindersType.AfterDueDate]: 'After due date',
  [AutomaticPaymentRemindersType.BeforeDueDate]: 'Before due date',
  [AutomaticPaymentRemindersType.OnDueDate]: 'On due date',
}

interface UseTrackAutomaticPaymentRemindersProps {
  // The old settings page leaves it out and keeps its own event names.
  section?: InvoicingSettingsSection
}

export const useTrackAutomaticPaymentReminders = ({ section }: UseTrackAutomaticPaymentRemindersProps = {}) => {
  const { track } = useSegment()
  const { trackInvoicingSettings } = useTrackInvoicingSettings({ section })

  const trackAutomaticPaymentReminders = useCallback(
    (eventDetail: string, eventType?: AutomaticPaymentRemindersType, payload?: Record<string, unknown>) => {
      const trackingEventTypePrefix = eventType ? `${trackingEventNameByType[eventType]} ` : ''
      const trackingEventDetail = `${trackingEventTypePrefix}${eventDetail}`

      if (section) {
        trackInvoicingSettings(trackingEventDetail, payload)
        return
      }

      track(`XXX - Invoicing Core - Settings - Organization - Invoicing tab - ${trackingEventDetail}`, {
        ...payload,
      })
    },
    [section, track, trackInvoicingSettings],
  )

  return { trackAutomaticPaymentReminders }
}
